module.exports = __webpack_public_path__ + "static/footer_bg-5776e58ca40ee9143022f9bff75f501a.png";